import type { ExternalSiteRule } from "../../types";
import { getNormalizedSixshopProHomeUrl } from "./common";
import { SITE_TYPE, SIXSHOP_PRO_PAGE } from "./const";

const sixshopPro: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async (args) => {
    const metaTag = args.html.querySelector('head meta[name="powered-by"]');

    if (metaTag) {
      const contentAttr = metaTag.getAttribute("content");
      if (contentAttr === "sixshop-pro") {
        return {
          siteType: SITE_TYPE,
          url: args.responseUrl,
          siteInfo: {
            type: SITE_TYPE,
          },
        };
      }

      return "INVALID";
    }

    return "INVALID";
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.LOGIN.target,
      label: "로그인 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.LOGIN.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.SIGNUP.target,
      label: "가입하기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.SIGNUP.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.FIND_PASSWORD.target,
      label: "비밀번호 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.FIND_PASSWORD.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.MY_PAGE.target,
      label: "마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.MY_PAGE.url
        }`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "mypageSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.CHECK_GUEST_ORDER.target,
      label: "비회원 주문 내역 조회 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.CHECK_GUEST_ORDER.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.target,
      label: "상품 카테고리 페이지",
      getExactUrl({ siteUrl, params }) {
        if (params?.categoryFilter) {
          return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
            SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.url
          }?${SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.param}=${
            params.categoryFilter
          }`;
        }
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.url
        }?${SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.param}=...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "categoryFilter",
          formType: "TEXT",
          placeholder: "categoryId",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.target,
      label: "상품 상세 페이지",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
            SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.url
          }/${params.productSlug}`;
        }
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.url
        }/...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.CART.target,
      label: "장바구니 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.CART.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.ORDER.target,
      label: "주문 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.ORDER.url
        }/...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "orderFilter",
          formType: "TEXT",
          placeholder: "orderId",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.POLICY.target,
      label: "이용약관 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.POLICY.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.PRIVACY.target,
      label: "개인정보처리방침 페이지",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.PRIVACY.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: SIXSHOP_PRO_PAGE.SIGNUP_PRIVACY.target,
      label: "개인정보 수집 및 이용에 대한 동의",
      getExactUrl({ siteUrl }) {
        return `${getNormalizedSixshopProHomeUrl(siteUrl)}${
          SIXSHOP_PRO_PAGE.SIGNUP_PRIVACY.url
        }`;
      },
    },
  ],
};

export default sixshopPro;
